import PermDataSettingRoundedIcon from '@mui/icons-material/PermDataSettingRounded';
import SaveIcon from '@mui/icons-material/Save'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Tab from '@mui/material/Tab'
import React from 'react'
import AssetDescription from './AssetDescription'
import { useRef } from 'react'
import AssetConfiguration from './AssetConfiguration'
import AssetAttachment from './AssetAttachment'
import AssetActivity from './AssetActivity'

function AssetDetails({ editAssetId, selectedAssetName }) {
    const [open, setOpen] = React.useState(false)
    const [value, setValue] = React.useState('1')
    const handleSubmitRef = useRef(null)

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    const handleUpdateAsset = () => {
        // call child submit if available
        try {
            if (
                handleSubmitRef &&
                handleSubmitRef.current &&
                typeof handleSubmitRef.current.submit === 'function'
            ) {
                handleSubmitRef.current.submit()
            }
        } catch (err) {
            console.error('Error calling child submit', err)
        }
    }
    return (
        <React.Fragment>
            <PermDataSettingRoundedIcon
                color="primary"
                style={{ cursor: 'pointer' }}
                onClick={handleClickOpen}
            />

            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        width: 800, // fixed width
                        height: 700, // fixed height
                        maxWidth: '100%', // optional for responsiveness
                        maxHeight: '100%', // optional to prevent overflow
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault()

                        // saveUser();
                        handleClose()
                    },
                }}
            >
                <DialogTitle>{selectedAssetName}</DialogTitle>
                <DialogContent>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1 },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <TabContext value={value}>
                            <Box
                                sx={{ borderBottom: 1, borderColor: 'divider' }}
                            >
                                <TabList
                                    onChange={handleChange}
                                    aria-label="Org's"
                                >
                                    <Tab label="Asset Description" value="1" />
                                    <Tab
                                        label="Asset Configuration"
                                        value="2"
                                    />
                                    <Tab
                                        label="Attachments"
                                        value="3"
                                    />
                                    <Tab
                                        label="Activity"
                                        value="4"
                                    />
                                </TabList>
                            </Box>
                            <TabPanel value="1">
                                <AssetDescription
                                    editAssetId={editAssetId}
                                    selectedAssetName={selectedAssetName}
                                    ref={handleSubmitRef}
                                />
                            </TabPanel>
                            <TabPanel value="2">
                                <AssetConfiguration
                                    editAssetId={editAssetId}
                                    selectedAssetName={selectedAssetName}
                                    ref={handleSubmitRef}
                                />
                            </TabPanel>
                            <TabPanel value="3">
                                <AssetAttachment
                                    editAssetId={editAssetId}
                                    selectedAssetName={selectedAssetName}
                                    ref={handleSubmitRef}
                                />
                            </TabPanel>
                            <TabPanel value="4">
                                <AssetActivity
                                    editAssetId={editAssetId}
                                    selectedAssetName={selectedAssetName}
                                    ref={handleSubmitRef}
                                />
                            </TabPanel>
                        </TabContext>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={handleUpdateAsset}
                        startIcon={<SaveIcon />}
                        sx={{
                            float: 'right',
                            border: '0',
                            minWidth: 150,
                            marginRight: '25px',
                            marginTop: '10px',
                            background:
                                'linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)',
                            boxShadow: '0 3px 5px 2px rgba(25, 118, 210, .3)',
                            '&:hover': {
                                background:
                                    'linear-gradient(45deg, #1565c0 30%, #1976d2 90%)',
                            },
                        }}
                    >
                        Update
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}
export default AssetDetails
